import styled from 'shared/utils/styled';

import Stack from '@mui/material/Stack';

export const Wrapper = styled(Stack)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const Label = styled('span')(() => ({
  fontSize: 15,
  fontFamily: 'NeoSansStd',
  fontWeight: 500,
}));

export const Value = styled('span')(() => ({
  fontSize: 17,
  fontWeight: 700,
}));

export const Percents = styled('span')(() => ({
  fontSize: 24,
  fontFamily: 'NeoSansStd',
  fontWeight: 400,
}));
